module.exports = __webpack_public_path__ + "static/what-you-get-banner-01a2ff895967fa530329449f13912b44.png";